import { getDashboardDivisionCenters } from '@api/getDashboardDivisionCenters';
import {
  CenterInfoType,
  DivisionsCentersFormattedItemType,
  centerLoading,
} from '@type/dashboard';
import { numberLanguageFormatter } from '@utils/utils';

export const dashboardDivisionAsonCentersApiHandler = (
  query: { divisionId: number; asonId: number; election_schedule_id?: string },
  setIsLoading: any,
  setDashboardCenters: any,
) => {
  if (query.divisionId) {
    setIsLoading((prev: any) => {
      prev.map((item: centerLoading) => {
        if (query.divisionId === item.divisionId) {
          item.loading = true;
        }
      });

      return [...prev];
    });

    getDashboardDivisionCenters({
      divisionId: query.divisionId,
      asonId: query.asonId,
      election_schedule_id: query.election_schedule_id || '',
    })
      .then((res) => {
        setDashboardCenters((prev: DivisionsCentersFormattedItemType[]) => {
          const data = prev.map((item: DivisionsCentersFormattedItemType) => {
            if (query.divisionId === item.divisionId) {
              const info: CenterInfoType[] = [];

              res?.data?.data?.centers?.forEach((nestedItem: any) => {
                info.push({
                  centerSerial: `${numberLanguageFormatter(
                    nestedItem?.center_serial || 0,
                  )}`,
                  totalVoters: `${nestedItem?.total_voters}`,
                  castedVote: `${nestedItem?.total_vote_cast}`,
                  value: `${nestedItem?.percentage || 0}`,
                  centerName: nestedItem.center_name,
                });
              });

              item.centers_info = info;
              item.centers = res?.data?.data?.centers || [];
              item.election_settings = `${
                res?.data?.data?.settings_name || ''
              }, জেলা: ${res?.data?.data?.zilla_name || ''}`;
              item.election_settings_id =
                res?.data?.data?.settings_code || null;
            }

            return item;
          });
          return [...data];
        });

        setIsLoading((prev: any) => {
          const loading = prev.map((item: centerLoading) => {
            if (query.divisionId === item.divisionId) {
              item.loading = false;
            }

            return item;
          });

          return [...loading];
        });
      })
      .catch((err) => {
        setIsLoading((prev: any) => {
          prev.map((item: centerLoading) => {
            if (query.divisionId === item.divisionId) {
              item.loading = false;
            }
          });

          return [...prev];
        });
      });
  }
};
